import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FaFacebookF,
  FaInstagram,
  FaWhatsapp,
  FaPhone,
  FaEnvelope,
  FaMapMarkerAlt,
  FaArrowUp,
} from "react-icons/fa";
import "./Footer.css";

function Footer() {
  const { t, i18n } = useTranslation();

  const isArabic = i18n.language === "ar";

  const openWhatsApp = () => {
    const whatsappNumber = "96103911681";

    window.open(
      `https://wa.me/${whatsappNumber}`,
      "_blank"
    );
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className={`footer ${isArabic ? "rtl" : "ltr"}`}>

      {/* =========================
          TOP DECORATION
      ========================= */}

      <div className="footer-top-line">
        <span></span>
        <span></span>
        <span></span>
      </div>


      <div className="footer-container">

        {/* =========================
            MAIN FOOTER
        ========================= */}

        <div className="footer-main">

          {/* BRAND */}

          <div className="footer-brand">

            <div className="footer-logo">

              <div className="footer-logo-icon">
                M
              </div>

              <div className="footer-logo-text">
                <strong>Madad</strong>

                <span>
                  {isArabic
                    ? "مركز مداد"
                    : "Madad Center"}
                </span>
              </div>

            </div>


            <p>
              {t("footer.description")}
            </p>


            {/* SOCIAL */}

            <div className="footer-socials">

              <a
                href="#https://www.facebook.com/profile.php?id=61588813003757&mibextid=ZbWKwL"
                aria-label="Facebook"
                className="facebook"
              >
                <FaFacebookF />
              </a>


              <a
                href="#https://www.instagram.com/medadhub.lb?stkn=NXA0YW5nbDFmejUz"
                aria-label="Instagram"
                className="instagram"
              >
                <FaInstagram />
              </a>


              <button
                type="button"
                onClick={openWhatsApp}
                aria-label="WhatsApp"
                className="whatsapp"
              >
                <FaWhatsapp />
              </button>

            </div>

          </div>


          {/* =========================
              QUICK LINKS
          ========================= */}

          <div className="footer-column">

            <h3>
              {t("footer.quickLinks")}
            </h3>


            <div className="footer-links">

              <Link to="/">
                {t("nav.home")}
              </Link>

              <Link to="/about">
                {t("nav.about")}
              </Link>

              <Link to="/services">
                {t("nav.services")}
              </Link>

              <Link to="/courses">
                {t("nav.courses")}
              </Link>

              <Link to="/trainers">
                {t("nav.trainers")}
              </Link>

              <Link to="/achievements">
                {t("nav.achievements")}
              </Link>

            </div>

          </div>


          {/* =========================
              SERVICES
          ========================= */}

          <div className="footer-column">

            <h3>
              {t("footer.servicesTitle")}
            </h3>


            <div className="footer-links">

              <Link to="/courses">
                {t("footer.courses")}
              </Link>

              <Link to="/registration">
                {t("footer.registration")}
              </Link>

              <Link to="/trainers">
                {t("footer.trainers")}
              </Link>

              <Link to="/achievements">
                {t("footer.achievements")}
              </Link>

              <Link to="/contact">
                {t("footer.contact")}
              </Link>

            </div>

          </div>


          {/* =========================
              CONTACT
          ========================= */}

          <div className="footer-column footer-contact">

            <h3>
              {t("footer.contactTitle")}
            </h3>


            {/* PHONE */}

            <div className="footer-contact-item">

              <div className="footer-contact-icon">
                <FaPhone />
              </div>

              <div>

                <span>
                  {t("footer.phone")}
                </span>

                <a href="tel:+96103911681">
                  +961 03 911 681
                </a>

              </div>

            </div>


            {/* WHATSAPP */}

            <div className="footer-contact-item">

              <div className="footer-contact-icon">
                <FaWhatsapp />
              </div>

              <div>

                <span>
                  WhatsApp
                </span>

                <button
                  type="button"
                  onClick={openWhatsApp}
                >
                  {t("footer.whatsapp")}
                </button>

              </div>

            </div>


            {/* EMAIL */}

            <div className="footer-contact-item">

              <div className="footer-contact-icon">
                <FaEnvelope />
              </div>

              <div>

                <span>
                  {t("footer.email")}
                </span>

                <a href="mailto:medadhub.lb@gmail.com">
                  medadhub.lb@gmail.com
                </a>

              </div>

            </div>


            {/* LOCATION */}

            <div className="footer-contact-item">

              <div className="footer-contact-icon">
                <FaMapMarkerAlt />
              </div>

              <div>

                <span>
                  {t("footer.location")}
                </span>

                <strong>
                  Madad Center
                </strong>

              </div>

            </div>

          </div>

        </div>


        {/* =========================
            CTA
        ========================= */}

        <div className="footer-cta">

          <div>

            <span>
              {t("footer.ctaTag")}
            </span>

            <h2>
              {t("footer.ctaTitle")}
            </h2>

          </div>


          <Link
            to="/contact"
            className="footer-cta-button"
          >
            {t("footer.ctaButton")}
          </Link>

        </div>


        {/* =========================
            BOTTOM
        ========================= */}

        <div className="footer-bottom">

          {/* COPYRIGHT */}

          <p className="footer-copyright">
            © {new Date().getFullYear()} Madad Center.
            {" "}
            {t("footer.rights")}
          </p>


          {/* BACK TO TOP */}

          <button
            type="button"
            className="back-to-top"
            onClick={scrollToTop}
            aria-label="Back to top"
          >
            <FaArrowUp />
          </button>


          {/* LUNORA BRANDING */}

          <p className="footer-made">

            <span className="footer-made-text">
              {isArabic
                ? "صُنع وتطوير بواسطة"
                : "Designed & Developed by"}
            </span>

            <a
              href="https://www.instagram.com/lunora.web"
              target="_blank"
              rel="noopener noreferrer"
              className="lunora-link"
            >
              Lunora Web
            </a>

          </p>

        </div>

      </div>

    </footer>
  );
}

export default Footer;